import { connect } from 'react-redux';
import Loader from 'react-loader-spinner'
import React, {Fragment} from 'react'
import AdminAddUser from '../AdminAddUser/AdminAddUser';
import ContentWrapper from '../ContentWrapper';
import MobileHeader from '../MobileHeader';
import PageHeader from '../PageHeader';
import UserList from '../UserList';
import UserTokens from '../UserTokens';

import styles from './AdminUserManager.module.css';

import packageJson from '../../../package.json';

const AdminUserContent = ({show}) => {
  if (show) {
    return (
      <Fragment>
        <div className={styles.UserListWrapper}>
          <UserList />
        </div>
        <div className={styles.AddUserWrapper}>
          <AdminAddUser />
          <UserTokens />
        </div>
      </Fragment>
    )
  } else return <div className={styles.LoaderWrapper}> <Loader type="Grid" color="#5e155e" height={100} width={100}  /></div>
}

const AdminUserManager = props => {
  return (
    <ContentWrapper>
      <div className={styles.AdminUserManager}>
        <MobileHeader>Admin User Manager</MobileHeader>
        <PageHeader title={`Admin (app version: ${packageJson.version})`} />
        <div className={styles.Body}>
          <AdminUserContent show={props.userList} />
        </div>
      </div>
    </ContentWrapper>
  )
}

const mapStateToProps = ({users}) => {
  return {
      userList: users.userList
  }
}

export default connect(mapStateToProps, null)(AdminUserManager)